import { defineMessages } from 'react-intl-next';

export default defineMessages({
    externalLinksSectionHeader: {
        id: 'cv.external-links.section.header',
        defaultMessage: 'Related resources',
        description: 'Header for the external links section',
    },
    externalLinksSectionShowMore: {
        id: 'cv.external-links.section.show-more',
        defaultMessage: 'Show all',
        description: 'Label for the external links Show all button',
    },
    externalLinksSectionShowLess: {
        id: 'cv.external-links.section.show-less',
        defaultMessage: 'Show fewer',
        description: 'Label for the external links Show all button',
    },
});
